import * as React from 'react'

import { Form } from 'lucide-react'

import { IGetResourceTemplatesQuery } from '~/client/graph/operations/generated/Resources.generated'
import CaretDownSelectorIcon from '~/client/src/shared/components/StruxhubInputs/StruxhubSelector/CaretDownSelectorIcon'
import { getResourceTypeLabels } from '~/client/src/shared/constants/resourceTypeLabels'

import { ResourceEditContext } from './ResourceEditContext'

type ResourceTemplate = NonNullable<
  IGetResourceTemplatesQuery['resourceTemplates']
>[number]

interface IProps {
  resourceTypeId: string
  templates: ResourceTemplate[]
  currentTemplateId: string | null
  onClick?: () => void
}

const ResourceEditFormSelector: React.FC<IProps> = ({
  resourceTypeId,
  templates,
  currentTemplateId,
  onClick,
}) => {
  const ctx = React.useContext(ResourceEditContext)
  const handleClick = onClick ?? ctx?.actions.openFormSelector

  const validTemplates = React.useMemo(
    () => templates.filter(t => t.id != null),
    [templates],
  )

  if (validTemplates.length < 2) return null

  const currentTemplate = validTemplates.find(
    t => String(t.id) === currentTemplateId,
  )

  return (
    <div className="tw:flex tw:flex-col tw:gap-1 tw:px-4 tw:pb-3 tw:border-0 tw:border-b tw:border-solid tw:border-border">
      <span className="tw:text-label-lg tw:text-muted-foreground">
        {getResourceTypeLabels(resourceTypeId).formLabel()}
      </span>
      <button
        type="button"
        onClick={handleClick}
        className="tw:relative tw:flex tw:items-center tw:gap-2 tw:h-10 tw:px-2 tw:rounded tw:border tw:border-solid tw:border-input tw:bg-background tw:text-body-lg tw:text-foreground tw:cursor-pointer tw:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-primary tw:hover:bg-muted/40"
      >
        <Form className="tw:size-4 tw:text-muted-foreground tw:shrink-0" />
        <span className="tw:flex-1 tw:text-left tw:truncate">
          {currentTemplate?.name || ''}
        </span>
        <CaretDownSelectorIcon />
      </button>
    </div>
  )
}

export default ResourceEditFormSelector
